var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenStatus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "is0stsf9wa",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EDA300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D66A00"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "url(#is0stsf9wa)",
    fillRule: "nonzero",
    transform: "translate(-1041 -405)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8 0c4.418 0 8 3.582 8 8s-3.582 8-8 8-8-3.582-8-8 3.582-8 8-8zm0 1.28C4.294 1.28 1.28 4.295 1.28 8c0 3.705 3.015 6.72 6.72 6.72 3.705 0 6.72-3.015 6.72-6.72 0-3.705-3.015-6.72-6.72-6.72zM6.667 4.136c.161 0 .317.058.439.165l3.654 3.197c.277.243.305.664.063.941-.02.022-.04.043-.063.063l-3.654 3.197c-.277.243-.699.215-.941-.063-.106-.121-.165-.277-.165-.439V4.803c0-.369.298-.667.667-.667z",
    transform: "translate(99 106) translate(352 167) translate(0 100) translate(580 25) translate(10 7)"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenStatus);
export default __webpack_public_path__ + "static/media/open-status.dceed8995fa190b2c2ae602d7457ff2d.svg";
export { ForwardRef as ReactComponent };